<div style="line-height: 14px" [innerHTML]="currentText | safeHtml"></div>
@if (!hideToggle) {
    <a (click)="toggleView()">Read {{ isCollapsed ? 'more' : 'less' }}</a>
}
